import { render, staticRenderFns } from "./SaveList.vue?vue&type=template&id=3185fbf1&"
import script from "./SaveList.vue?vue&type=script&lang=js&"
export * from "./SaveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports